import { Modal, Button } from "react-bootstrap";

function SWComponentModal({ show, onClose, component }) {
  if (!component) return null;

  const getRowStyle = (index) => ({
    "--bs-table-bg": index % 2 === 0 ? "rgba(25, 135, 84, 0.06)" : "#ffffff"
  });

  const renderValue = (value) => value || <span className="text-muted">-</span>;

  const swRequirements = component.SWRequirements ?? [];

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          SW Component {component.number}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <table className="table">
          <tbody>
            <tr style={getRowStyle(0)}>
              <th style={{ width: "160px" }}>Number</th>
              <td>{renderValue(component.number)}</td>
            </tr>
            <tr style={getRowStyle(1)}>
              <th>Name</th>
              <td style={{ whiteSpace: "pre-wrap" }}>{renderValue(component.name)}</td>
            </tr>
            <tr style={getRowStyle(2)}>
              <th>SW Requirements</th>
              <td>
                {swRequirements.length ? (
                  <div className="d-flex flex-column gap-1">
                    {swRequirements.map((requirement) => (
                      <div key={requirement.id}>
                        <span className="fw-semibold">{requirement.number}</span>
                        {requirement.name ? (
                          <span className="text-muted"> - {requirement.name}</span>
                        ) : null}
                      </div>
                    ))}
                  </div>
                ) : (
                  <span className="text-muted">-</span>
                )}
              </td>
            </tr>
            <tr style={getRowStyle(3)}>
              <th>Status</th>
              <td>{renderValue(component.status)}</td>
            </tr>
            <tr style={getRowStyle(4)}>
              <th>User ID</th>
              <td>{renderValue(component.userId)}</td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SWComponentModal;
